module.exports = __webpack_public_path__ + "static/media/Daniel_Hartstein_Picture.89cd4fc4.jpg";